import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-deeplink',
  templateUrl: './deeplink.component.html',
  styleUrls: ['./deeplink.component.scss']
})
export class DeeplinkComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    this.triggerAutoClick();
  }

  @ViewChild('myDiv') myDiv: ElementRef;

  triggerAutoClick() {
    let el: HTMLElement = this.myDiv.nativeElement as HTMLElement;
    el.click();
  }

}



// WEBPACK FOOTER //
// ./src/app/deeplink/deeplink.component.ts